module.exports = __webpack_public_path__ + "img/no-network.62b7fcc0.png";